import React, { useState, useCallback, useEffect } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import Card from 'components/inputs/Card';
import Button from 'components/inputs/Button';
import { FiEdit2 } from 'react-icons/fi';
import { RiDeleteBinLine } from 'react-icons/ri';
import { Row, Col, Modal, Spinner } from 'react-bootstrap';
import * as _ from 'lodash';
import SearchBox from 'components/general/SearchBox';
import { useDispatch, useSelector } from 'react-redux';
import RegionForm from './RegionForm';
import { DELETE_REGION, FETCH_REGION, GET_REGION } from 'actions/address';
import ReactPagination from 'components/general/ReactPagination';
import DeleteModal from 'components/general/DeleteModal';
import { DELETE_STATUS_CODE } from 'components/common/constant';
import { BiSort } from 'react-icons/bi';

const RegionList = () => {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [regionId, setRegionId] = useState('');
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });
  const [pageWiseRegionData, setPageWiseRegionData] = useState([]);

  const regionList = useSelector((state) => state.region.regions);
  const isLoader = useSelector((state) => state.region.isLoading);
  const page = useSelector((state) => state.region.page);
  const totalData = useSelector((state) => state.region.total);
  const limit = useSelector((state) => state.region.limit);
  const totalPages = useSelector((state) => state.region.totalPages);

  const regionData = regionList.filter(({ id: id1 }) => pageWiseRegionData.some(({ id: id2 }) => id2 === id1));

  const getRegion = useCallback(
    (data = {}) => {
      if (searchText) {
        const searchRegionData = {
          ...data,
          search: searchText,
        };
        dispatch({
          type: FETCH_REGION.REQUEST,
          payload: searchRegionData,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                setPageWiseRegionData(res.data.results);
              }
            }
          },
        });
      } else {
        dispatch({
          type: FETCH_REGION.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                setPageWiseRegionData(res.data.results);
              }
            }
          },
        });
      }
    },
    [pageWiseRegionData, searchText]
  );

  const getRegionDetail = useCallback((id) => {
    dispatch({ type: GET_REGION.REQUEST, payload: id });
  }, []);

  const handleCloseDeleteModel = () => {
    setShowDeleteModal(false);
    setRegionId('');
  };

  const deleteRegion = useCallback(
    () =>
      dispatch({
        type: DELETE_REGION.REQUEST,
        payload: regionId,
        cb: (res) => {
          if (_.get(res, 'status', '') === DELETE_STATUS_CODE) {
            handleCloseDeleteModel();
            getRegion({ page: 1 });
          }
        },
      }),
    [regionId]
  );

  useEffect(() => {
    getRegion();
  }, []);

  const handleSearch = () => {
    getRegion({});
  };

  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else {
        const data = {
          page: page.selected + 1,
        };
        getRegion(data);
      }
    },
    [sortByItem]
  );

  const handleCloseFormRegion = () => {
    setShowForm(false);
    setIsEdit(false);
  };

  const getSortByItem = (name, order, page) => {
    const sortedOrder = order || 'asc';
    if (page) {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      };
      getRegion(data);
    } else {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      getRegion(data);
    }
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  return (
    <>
      <LayoutContainer>
        <AdminHeader title="Regions" />
        <div className="page-content-wrapper scrollable">
          <div className="countryList-page">
            <Card>
              <div className="countryList-page-wrapper">
                <Row className="countryList-search-box">
                  <Col xl={10} lg={9} md={8} className="countryList-search-inputBox">
                    <SearchBox
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          handleSearch();
                        }
                      }}
                    />
                  </Col>
                  <Col xl={2} lg={3} md={4} className="countryList-search-boxButton">
                    <Button
                      className="countryList-search-box-Btn"
                      onClick={() => {
                        setShowForm(true);
                        setIsEdit(false);
                      }}
                    >
                      Add Region
                    </Button>
                  </Col>
                </Row>
                <div className="countryList-table">
                  <div className="table-responsive">
                    <table className="record-list-table">
                      <thead>
                        <tr>
                          <th>
                            <div className="sorting">
                              <span>Region Name</span>
                              <span className="ico" onClick={() => handleSorting('name', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th className="action-col">
                            <span>Action</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoader ? (
                          <tr>
                            <td colSpan={10} className="border-0">
                              <div className="loader--block">
                                <Spinner as="span" animation="border" size="sm" role="status" />
                                <span className="ps-2">Loading...</span>
                              </div>
                            </td>
                          </tr>
                        ) : _.isEmpty(regionData) ? (
                          <tr>
                            <td colSpan={6} className="border-0">
                              <div className="empty-data-block">No records found.</div>
                            </td>
                          </tr>
                        ) : (
                          !(isLoader || _.isUndefined(isLoader)) &&
                          _.map(regionData, (item, key) => {
                            return (
                              <tr key={`region-${key}`}>
                                <td>{_.get(item, 'name')}</td>
                                <td>
                                  <span
                                    className="countryList-table-editIcon"
                                    onClick={() => {
                                      setShowForm(true);
                                      getRegionDetail(_.get(item, 'id'));
                                      setIsEdit(true);
                                    }}
                                  >
                                    <FiEdit2 title="Edit" />
                                  </span>
                                  <span
                                    className="countryList-table-deleteIcon"
                                    onClick={() => {
                                      setShowDeleteModal(true);
                                      setRegionId(_.get(item, 'id', ''));
                                    }}
                                  >
                                    <RiDeleteBinLine title="Delete" />
                                  </span>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                    {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(regionData) && (
                      <ReactPagination
                        currentPage={page}
                        limit={limit}
                        total={totalData}
                        handlePageClick={(pageVal) => handlePageClick(pageVal)}
                        totalPages={totalPages}
                        marginPagesDisplayed={1}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
        {showForm && (
          <Modal show={showForm} size="lg" centered>
            <RegionForm onClose={handleCloseFormRegion} isEdit={isEdit} onSuccess={getRegion} />
          </Modal>
        )}
        {showDeleteModal && (
          <Modal show={showDeleteModal} centered onHide={handleCloseDeleteModel}>
            <DeleteModal title="region" onClose={handleCloseDeleteModel} onRemove={deleteRegion} />
          </Modal>
        )}
      </LayoutContainer>
    </>
  );
};
export default RegionList;
